import {
  MetricSummaryCard,
  type MetricSummaryCardProps,
} from '../MetricSummaryCard/MetricSummaryCard';

/**
 * Figma `972:20770`. `reach`, relabelled — the corpus carries no per-row author
 * identity, so there is nothing to count distinctly and reach is the audience
 * figure it has. The caveat is real and stays in the tooltip rather than being
 * hidden: summed reach counts a person twice if they saw two mentions.
 */
export function TotalUniqueAudienceCard(props: MetricSummaryCardProps) {
  return (
    <MetricSummaryCard
      {...props}
      copy={{
        title: 'Total unique audience',
        helpText: 'The audience your mentions reached across the period.',
        helpSupportingText:
          'Reach summed over every mention, so somebody who saw two of them is counted twice — an upper bound on the audience rather than a headcount of it.',
      }}
    />
  );
}
